module.exports = __webpack_public_path__ + "img/c06_unitbowman_Normal_ua.f0b9173d.webp";